// Containers
import classNames from "classnames";

// Containers
import AttemptContainer from "containers/atoms/AttemptContainer";

import "./styles.sass";

const GirlsElements = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const logoClass = classNames("GirlsElements__logo", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });
  const womanLeftClass = classNames("GirlsElements-team__left", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });
  const womanRightClass = classNames("GirlsElements-team__right", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });
  const backClass = classNames("GirlsElements-back", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });
  return (
    <div className="GirlsElements">
      <div className={logoClass} />
      <AttemptContainer />
      <div className={backClass} />
      <div className="GirlsElements-team">
        <div className={womanLeftClass} />
        <div className={womanRightClass} />
      </div>
    </div>
  );
};

export default GirlsElements;
